import React, { useCallback, useMemo, useState } from 'react';
import { AppButton } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import Permissions from '@/common/permissions';
import { ModalWrapper } from '@/components';
import { useCurrentOrganization, useHasAccess } from '@/modules/core/hooks';

import CreateCopayAdjudicationForm from './CreateCopayAdjudicationForm';

const CreateCopayAdjudication = () => {
  const [isVisible, setVisible] = useState(false);
  const hasEditCopayAccess = useHasAccess([{ permission: Permissions.EDIT_COPAY }]);
    const {
      observingOrganization: {
        type,
      },
    } = useCurrentOrganization();
  const isSubsidiary = useMemo(() => type === OrganizationTypes.subsidiary, [type]);
  const handleToggle = useCallback(() => {
    setVisible(!isVisible);
  }, [isVisible]);
  if (!hasEditCopayAccess || isSubsidiary) {
    return null;
  }
  return (
    <>

      <AppButton
        testId="create-copay-adjudication"
        onClick={handleToggle}
      >
        Add New Copay Group
      </AppButton>
      <ModalWrapper
        testId="create-copay-adjudication"
        visible={isVisible}
        title="Add New Copay Group"
        onSetVisible={handleToggle}
        // {...isOverflowHidden ? { wrapperStyle: { overflow: 'hidden' } } : {}}
      >
        {/* <Prompt
          when={isFormDirty}
          message={CONFIRM_TEXT}
        /> */}
        <CreateCopayAdjudicationForm
          onClose={handleToggle}
        />
      </ModalWrapper>
    </>
  );
};
export default CreateCopayAdjudication;
